import React, { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import emailjs from "@emailjs/browser";
import "../../styles/specialEvents.scss";
export default function Events1() {
  const renderAlert = () => {
    return (
      <div>
        <p>
          <FontAwesomeIcon icon="fa-solid fa-check" />
          &nbsp;We received your message, we'll get back to you as soon as we
          can.
        </p>
      </div>
    );
  };
  const form = useRef();
  const [status, setStatus] = useState("");
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("gmail", "template_beqqriw", form.current, "n2unFpBuyeReh7sGG")
      .then(
        (result) => {
          console.log(result.text);
          setStatus("SUCCESS");
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };

  useEffect(() => {
    if (status === "SUCCESS") {
      setTimeout(() => {
        setStatus("");
      }, 3000);
    }
  }, [status]);
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {/* specialEvents Hero Section */}
      <div className="container-fluid p-0 relative" id="specialEventHero">
        <div className="container-fluid m-0 absolute" id="specialEventHeroText">
          <h1>Special Events</h1>
        </div>
      </div>
      {/* specialEvents Divider */}
      <div className="container-fluid p-5" id="specialEventsDivider">
        <div className="row text-center">
          <div className="col-sm-12 specialEvents_divider_text">
            <h1>Celebrations Made Meaningful</h1>
          </div>
          <div className="col-sm-10 mx-auto specialEvents_divider_text">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam
              unde explicabo tempore. Eius, non sint sit quia a accusamus,
              corrupti eos inventore nam temporibus at odio alias animi, harum
              debitis! Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              Voluptatum unde saepe iure optio a nemo esse! Neque quidem
              blanditiis dolore dolorum impedit? Vero quas fugit nesciunt!
              Doloremque nemo quibusdam sunt.
            </p>
          </div>
        </div>
      </div>
      {/* specialEvents Contact Form */}
      <div className="container specialEventsFormContainer">
        <div className="form-header p-5">
          <div className="row text-center">
            <div className="col-12">
              <h2>Request for a Quote</h2>
            </div>
            <div className="col-12 col-lg-8 mx-auto">
              <p>
                Make your dreams come true with our impeccable event planning
                service. Simply provide us with your information and our highly
                professional concierge will get in touch to serve you.
              </p>
            </div>
          </div>
        </div>
        <div className="specialEventsForm-container mx-auto pt-3">
          <h3 id="form-title">Contact Information</h3>
          <form ref={form} onSubmit={sendEmail}>
            <div className="row" id="specialEventForm">
              <div className="col-12 gy-3">
                <label htmlFor="nameInput">Type of event</label>
                <select name="eventType" className="form-control" required>
                  <option value="">Luxury Dine Cruise</option>
                  <option value="">Anniversary Package</option>
                </select>
              </div>
              <div className="col-lg-6 col-12 gy-3">
                <label htmlFor="nameInput">Full Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  placeholder="Juan Dela Cruz"
                  required
                />
              </div>
              <div className="col-lg-6 col-12 gy-3">
                <label htmlFor="mobileInput">Mobile Number</label>
                <input
                  type="tel"
                  name="mobileNum"
                  className="form-control"
                  placeholder="63-967-258-6160"
                  required
                ></input>
              </div>
              <div className=" col-12 gy-3">
                <label htmlFor="emailInput">E-mail Address</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  id="emailInput"
                  required
                  placeholder="Ex. example@example.com"
                />
              </div>
              <div className="col-12 gy-3">
                <label>Message</label>
                <textarea
                  name="message"
                  className="form-control"
                  placeholder="Good Day..."
                  required
                />
                {status && renderAlert()}
              </div>
              <div className="col-2 mx-auto p-1 gy-3">
                <input
                  type="submit"
                  value="Send"
                  className="main-btn-contact m-0"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </motion.div>
  );
}
